import Link from "next/link";
import { useEffect, useState } from "react";
import { CloseIcon } from "./nav/Icons";

const STORAGE_KEY = "topBannerDismissed";

export default function TopBanner({
  title,
  text,
  link,
  target = "_blank",
}: {
  title: string;
  text: string;
  link: string;
  buttonLabel: string;
  target?: React.HTMLAttributeAnchorTarget;
}) {
  const [show, setShow] = useState<boolean | null>(null);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    setShow(!dismissed);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setShow(false);
  };

  if (show === null || !show) return null;

  return (
    <div className="flex items-center gap-x-6 bg-gray-900 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p className="text-sm/6 text-white">
        <Link target={target} href={link}>
          <strong className="font-semibold">{title}</strong>
          {text}&nbsp;<span aria-hidden="true">&rarr;</span>
        </Link>
      </p>
      <div className="flex flex-1 justify-end">
        <button
          type="button"
          className="-m-3 p-3 focus-visible:-outline-offset-4"
          onClick={handleDismiss}
        >
          <span className="sr-only">Dismiss</span>
          <CloseIcon className="h-5 w-5 stroke-gray-50 text-white" />
        </button>
      </div>
    </div>
  );
}
